import { React, useState, useEffect } from "react";
import { salesforceBannerAPI } from "../API/salesforceAPI";
import { Container } from "react-bootstrap";
import AnimatedText from "react-animated-text-content";
import { marketingcloudbannerAPI } from "../API/marketingcloudAPI";
import { smartbannerAPI } from "../API/smartAPI";
import { digitalbannerAPI,dynamicbannerAPI } from "../API/digitalAPI";
import { technologybannerAPI } from "../API/technologyAPI";
import { cloudbannerAPI } from "../API/cloudAPI";

import { careersbannerAPI } from "../API/careersAPI";
import { benefitbannerAPI } from "../API/benefitAPI";
import { employeebannerAPI } from "../API/employeeAPI";
import { meetbannerAPI } from "../API/meetTeamAPI";
import { eventbannerAPI } from "../API/eventAPI";
import { industrybannerAPI } from "../API/industryAPI";
import { generativeaibannerAPI } from "../API/generativeaiAPI";
import { cyberSecuritybannerAPI } from "../API/cyberSecurityAPI";
import { futuristicbannerAPI } from "../API/futuristicAPI";
import Img from "react-cool-img";
import { commerceBannerAPI } from "../API/commerceAPI";
import { sapbannerAPI } from "../API/sapAPI";
import { Animated } from "react-animated-css";
import LoadingBox from "./LoadingBox";
import { motion, AnimatePresence } from "framer-motion";
import { servicebannerAPI } from "../API/industryAPI";
import { raasbannerAPI } from "../API/industryAPI";

const text = {
  initial: {
    y: 0,
    opacity: 0,
  },
  animate: {
    y: 0,
    opacity: ["0", "0.25", "0.5", "0.75", "1"],
    transition: {
      duration: 1.5,
      delay: 0.2,
      type: "spring",
      stiffness: 100,
    },
  },
};

const PageBanner = () => {
  const [bannerData, setBannerData] = useState([]);
  const [bannerImage, setBannerImage] = useState("");
const[bannerTittleColor,setBannerTittleColor]=useState('')
  const [loading, setLoading] = useState(true);
  
 useEffect(()=>{
  
  const params= window.location.href.split('/')[3] 
  let css;
  if(params.includes('?'))
    {
 css=params.split('?')[0]
  }
  else{
    css=params
  }
    
    setBannerTittleColor(`bics-banner-${css}`)
      
  
 },[])
  const handleLoading = () => {
    setLoading(true);
  };
  const getAllBannerData = () => {
    var config = { "Access-Control-Allow-Origin": "*" };

    if (window.location.href.split('/')[3] =="ecommercecloud") {
      dynamicbannerAPI(
        config,
        (response) => {
          //success
          setBannerData(response.data[0]);
          // console.log("banner data", response.data[0]);
          const image_banner = response.data[0].contentBackground;
          const image_url = process.env.REACT_APP_BASE_URL + image_banner;
          setBannerImage(image_url);
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        },
        (err) => {
          //error
          console.log(err);
        },'getPage2Block16'
      
      );
    }    
    else if (window.location.href.split('/')[3] =="salescloud") {
      dynamicbannerAPI(
        config,
        (response) => {
          //success
          setBannerData(response.data[0]);
          // console.log("banner data", response.data[0]);
          const image_banner = response.data[0].contentBackground;
          const image_url = process.env.REACT_APP_BASE_URL + image_banner;
          setBannerImage(image_url);
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        },
        (err) => {
          //error
          console.log(err);
        },'getPage2Block13'
     
      );
    }

    else if (window.location.href.split('/')[3] =="servicecloud") {
      dynamicbannerAPI(
        config,
        (response) => {
          //success
          setBannerData(response.data[0]);
          // console.log("banner data", response.data[0]);
          const image_banner = response.data[0].contentBackground;
          const image_url = process.env.REACT_APP_BASE_URL + image_banner;
          setBannerImage(image_url);
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        },
        (err) => {
          //error
          console.log(err);
        },'getPage2Block14'
      
      );
    }
    else if (window.location.href.split('/')[3] =="servicecloud") {
      dynamicbannerAPI(
        config,
        (response) => {
          //success
          setBannerData(response.data[0]);
          // console.log("banner data", response.data[0]);
          const image_banner = response.data[0].contentBackground;
          const image_url = process.env.REACT_APP_BASE_URL + image_banner;
          setBannerImage(image_url);
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        },
        (err) => {
          //error
          console.log(err);
        },'getPage2Block14'
      
      );
    }
    else if (window.location.href.split('/')[3] =="salesforce") {
      dynamicbannerAPI(
        config,
        (response) => {
          //success
          setBannerData(response.data[0]);
          // console.log("banner data", response.data[0]);
          const image_banner = response.data[0].contentBackground;
          const image_url = process.env.REACT_APP_BASE_URL + image_banner;
          setBannerImage(image_url);
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        },
        (err) => {
          //error
          console.log(err);
        },'getPage2Block1'
      
      );
    }
    else if (window.location.href.split('/')[3] =="servicecloud") {
      dynamicbannerAPI(
        config,
        (response) => {
          //success
          setBannerData(response.data[0]);
          // console.log("banner data", response.data[0]);
          const image_banner = response.data[0].contentBackground;
          const image_url = process.env.REACT_APP_BASE_URL + image_banner;
          setBannerImage(image_url);
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        },
        (err) => {
          //error
          console.log(err);
        },'getPage2Block14'
      
      );
    }
    else if (window.location.href.split('/')[3] =="einstein") {
      dynamicbannerAPI(
        config,
        (response) => {
          //success
          setBannerData(response.data[0]);
          // console.log("banner data", response.data[0]);
          const image_banner = response.data[0].contentBackground;
          const image_url = process.env.REACT_APP_BASE_URL + image_banner;
          setBannerImage(image_url);
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        },
        (err) => {
          //error
          console.log(err);
        },'getpage2block17'
      
      );
    }
    else if (window.location.href.split('/')[3] =="digitalcms") {
      dynamicbannerAPI(
        config,
        (response) => {
          //success
          setBannerData(response.data[0]);
          // console.log("banner data", response.data[0]);
          const image_banner = response.data[0].contentBackground;
          const image_url = process.env.REACT_APP_BASE_URL + image_banner;
          setBannerImage(image_url);
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        },
        (err) => {
          //error
          console.log(err);
        },'getPage5Block17'
      
      );
    }
    else if (window.location.href.split('/')[3] =="ecommerce") {
      dynamicbannerAPI(
        config,
        (response) => {
          //success
          setBannerData(response.data[0]);
          // console.log("banner data", response.data[0]);
          const image_banner = response.data[0].contentBackground;
          const image_url = process.env.REACT_APP_BASE_URL + image_banner;
          setBannerImage(image_url);
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        },
        (err) => {
          //error
          console.log(err);
        },'getPage5Block18'
      
      );
    }
    else if (window.location.href.split('/')[3] =="mobility") {
      dynamicbannerAPI(
        config,
        (response) => {
          //success
          setBannerData(response.data[0]);
          // console.log("banner data", response.data[0]);
          const image_banner = response.data[0].contentBackground;
          const image_url = process.env.REACT_APP_BASE_URL + image_banner;
          setBannerImage(image_url);
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        },
        (err) => {
          //error
          console.log(err);
        },'getPage5Block19'
      
      );
    }
    else if (window.location.href.split('/')[3] =="healthcloud") {
      dynamicbannerAPI(
        config,
        (response) => {
          //success
          setBannerData(response.data[0]);
          // console.log("banner data", response.data[0]);
          const image_banner = response.data[0].contentBackground;
          const image_url = process.env.REACT_APP_BASE_URL + image_banner;
          setBannerImage(image_url);
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        },
        (err) => {
          //error
          console.log(err);
        },'getPage2Block15'
      
      );
    }
    else if (window.location.href.split('/')[3] =="technologies") {
      dynamicbannerAPI(
        config,
        (response) => {
          //success
          setBannerData(response.data[0]);
          // console.log("banner data", response.data[0]);
          const image_banner = response.data[0].contentBackground;
          const image_url = process.env.REACT_APP_BASE_URL + image_banner;
          setBannerImage(image_url);
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        },
        (err) => {
          //error
          console.log(err);
        },'getPage5Block20'
      
      );
    }
    else if (window.location.href.split('/')[3] =="uiux") {
      dynamicbannerAPI(
        config,
        (response) => {
          //success
          setBannerData(response.data[0]);
          // console.log("banner data", response.data[0]);
          const image_banner = response.data[0].contentBackground;
          const image_url = process.env.REACT_APP_BASE_URL + image_banner;
          setBannerImage(image_url);
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        },
        (err) => {
          //error
          console.log(err);
        },'getPage5Block21'
      
      );
    }
    else if (window.location.href.split('/')[3] =="lms") {
      dynamicbannerAPI(
        config,
        (response) => {
          //success
          setBannerData(response.data[0]);
          // console.log("banner data", response.data[0]);
          const image_banner = response.data[0].contentBackground;
          const image_url = process.env.REACT_APP_BASE_URL + image_banner;
          setBannerImage(image_url);
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        },
        (err) => {
          //error
          console.log(err);
        },'getPage5Block22'
      
      );
    }
    else if (window.location.href.split('/')[3] =="analytics") {
      dynamicbannerAPI(
        config,
        (response) => {
          //success
          setBannerData(response.data[0]);
          // console.log("banner data", response.data[0]);
          const image_banner = response.data[0].contentBackground;
          const image_url = process.env.REACT_APP_BASE_URL + image_banner;
          setBannerImage(image_url);
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        },
        (err) => {
          //error
          console.log(err);
        },'getPage4Block8'
      
      );
    }
    else if (window.location.href.split('/')[3] =="automations") {
      dynamicbannerAPI(
        config,
        (response) => {
          //success
          setBannerData(response.data[0]);
          // console.log("banner data", response.data[0]);
          const image_banner = response.data[0].contentBackground;
          const image_url = process.env.REACT_APP_BASE_URL + image_banner;
          setBannerImage(image_url);
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        },
        (err) => {
          //error
          console.log(err);
        },'getPage4Block9'
      
      );
    }
    else if (window.location.href.split('/')[3] =="devops") {
      dynamicbannerAPI(
        config,
        (response) => {
          //success
          setBannerData(response.data[0]);
          // console.log("banner data", response.data[0]);
          const image_banner = response.data[0].contentBackground;
          const image_url = process.env.REACT_APP_BASE_URL + image_banner;
          setBannerImage(image_url);
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        },
        (err) => {
          //error
          console.log(err);
        },'getPage4Block10'
      
      );
    }
  
    else if (window.location.href.split('/')[3] =="intelligent") {
      dynamicbannerAPI(
        config,
        (response) => {
          //success
          setBannerData(response.data[0]);
          // console.log("banner data", response.data[0]);
          const image_banner = response.data[0].contentBackground;
          const image_url = process.env.REACT_APP_BASE_URL + image_banner;
          setBannerImage(image_url);
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        },
        (err) => {
          //error
          console.log(err);
        },'getPage19Block4'
      
      );
    }
  
  
    else if (window.location.href.includes("analytics") === true) {
      dynamicbannerAPI(
        config,
        (response) => {
          //success
          setBannerData(response.data[0]);
          // console.log("banner data", response.data[0]);
          const image_banner = response.data[0].contentBackground;
          const image_url = process.env.REACT_APP_BASE_URL + image_banner;
          setBannerImage(image_url);
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        },
        (err) => {
          //error
          console.log(err);
        },'getPage5Block1'
      
      );
    }
    else if (window.location.href.includes("automations") === true) {
      dynamicbannerAPI(
        config,
        (response) => {
          //success
          setBannerData(response.data[0]);
          // console.log("banner data", response.data[0]);
          const image_banner = response.data[0].contentBackground;
          const image_url = process.env.REACT_APP_BASE_URL + image_banner;
          setBannerImage(image_url);
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        },
        (err) => {
          //error
          console.log(err);
        },'getPage5Block1'
      
      );
    }
   
    else if (window.location.href.includes("uiux") === true) {
      digitalbannerAPI(
        config,
        (response) => {
          //success
          setBannerData(response.data[0]);
          //console.log("banner data", response.data[0]);
          const image_banner = response.data[0].contentBackground;
          const image_url = process.env.REACT_APP_BASE_URL + image_banner;
          setBannerImage(image_url);
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        },
        (err) => {
          //error
          console.log(err);
        }
      );
    } 
    else if (window.location.href.includes("technologies") === true) {
      digitalbannerAPI(
        config,
        (response) => {
          //success
          setBannerData(response.data[0]);
          //console.log("banner data", response.data[0]);
          const image_banner = response.data[0].contentBackground;
          const image_url = process.env.REACT_APP_BASE_URL + image_banner;
          setBannerImage(image_url);
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        },
        (err) => {
          //error
          console.log(err);
        }
      );
    } 
    else if (window.location.href.includes("marketingcloud") === true) {
      marketingcloudbannerAPI(
        config,
        (response) => {
          //success
          setBannerData(response.data[0]);
          // console.log("banner data", response.data[0]);
          const image_banner = response.data[0].contentBackground;
          const image_url = process.env.REACT_APP_BASE_URL + image_banner;
          setBannerImage(image_url);
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        },
        (err) => {
          //error
          console.log(err);
        }
      );
    } else if (window.location.href.includes("smart") === true) {
      smartbannerAPI(
        config,
        (response) => {
          //success
          setBannerData(response.data[0]);
          // console.log("banner data", response.data[0]);
          const image_banner = response.data[0].contentBackground;
          const image_url = process.env.REACT_APP_BASE_URL + image_banner;
          setBannerImage(image_url);
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        },
        (err) => {
          //error
          console.log(err);
        }
      );
    } else if (window.location.href.includes("digital") === true) {
      digitalbannerAPI(
        config,
        (response) => {
          //success
          setBannerData(response.data[0]);
          //console.log("banner data", response.data[0]);
          const image_banner = response.data[0].contentBackground;
          const image_url = process.env.REACT_APP_BASE_URL + image_banner;
          setBannerImage(image_url);
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        },
        (err) => {
          //error
          console.log(err);
        }
      );
    } 
   
    else if (window.location.href.includes("technology") === true) {
      technologybannerAPI(
        config,
        (response) => {
          //success
          setBannerData(response.data[0]);
          //console.log("banner data", response.data[0]);
          const image_banner = response.data[0].contentBackground;
          const image_url = process.env.REACT_APP_BASE_URL + image_banner;
          setBannerImage(image_url);
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        },
        (err) => {
          //error
          console.log(err);
        }
      );
    } else if (window.location.href.includes("cloud") === true) {
      cloudbannerAPI(
        config,
        (response) => {
          //success

          setBannerData(response.data[0]);
          //console.log("banner data", response.data[0]);
          const image_banner = response.data[0].contentBackground;
          const image_url = process.env.REACT_APP_BASE_URL + image_banner;
          setBannerImage(image_url);
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        },
        (err) => {
          //error
          console.log(err);
        }
      );
    } else if (window.location.href.includes("meetourteam") === true) {
      meetbannerAPI(
        config,
        (response) => {
          //success

          setBannerData(response.data[0]);
          //console.log("banner data", response.data[0]);
          const image_banner = response.data[0].contentBackground;
          const image_url = process.env.REACT_APP_BASE_URL + image_banner;
          setBannerImage(image_url);
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        },
        (err) => {
          //error
          console.log(err);
        }
      );
    } else if (window.location.href.includes("employee") === true) {
      employeebannerAPI(
        config,
        (response) => {
          //success

          setBannerData(response.data[0]);
          // console.log("banner data", response.data[0]);
          const image_banner = response.data[0].contentBackground;
          const image_url = process.env.REACT_APP_BASE_URL + image_banner;
          setBannerImage(image_url);
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        },
        (err) => {
          //error
          console.log(err);
        }
      );
    } else if (window.location.href.includes("events") === true) {
      eventbannerAPI(
        config,
        (response) => {
          //success

          setBannerData(response.data[0]);
          // console.log("banner data", response.data[0]);
          const image_banner = response.data[0].contentBackground;
          const image_url = process.env.REACT_APP_BASE_URL + image_banner;
          setBannerImage(image_url);
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        },
        (err) => {
          //error
          console.log(err);
        }
      );
    } else if (window.location.href.includes("careers") === true) {
      careersbannerAPI(
        config,
        (response) => {
          //success

          setBannerData(response.data[0]);
          //console.log("banner data", response.data[0]);
          const image_banner = response.data[0].contentBackground;
          const image_url = process.env.REACT_APP_BASE_URL + image_banner;
          setBannerImage(image_url);
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        },
        (err) => {
          //error
          console.log(err);
        }
      );
    } else if (window.location.href.includes("benefits") === true) {
      benefitbannerAPI(
        config,
        (response) => {
          //success

          setBannerData(response.data[0]);
          // console.log("banner data", response.data[0]);
          const image_banner = response.data[0].contentBackground;
          const image_url = process.env.REACT_APP_BASE_URL + image_banner;
          setBannerImage(image_url);
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        },
        (err) => {
          //error
          console.log(err);
        }
      );
    } else if (window.location.href.includes("industry") === true) {
      industrybannerAPI(
        config,
        (response) => {
          //success

          setBannerData(response.data[0]);
          // console.log("banner data", response.data[0]);
          const image_banner = response.data[0].contentBackground;
          const image_url = process.env.REACT_APP_BASE_URL + image_banner;
          setBannerImage(image_url);
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        },
        (err) => {
          //error
          console.log(err);
        }
      );
    } else if (window.location.href.includes("generativeai") === true) {
      generativeaibannerAPI(
        config,
        (response) => {
          //success

          setBannerData(response.data[0]);
          // console.log("banner data", response.data[0]);
          const image_banner = response.data[0].contentBackground;
          const image_url = process.env.REACT_APP_BASE_URL + image_banner;
          setBannerImage(image_url);
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        },
        (err) => {
          //error
          console.log(err);
        }
      );
    } else if (window.location.href.includes("cybersecurity") === true) {
      cyberSecuritybannerAPI(
        config,
        (response) => {
          //success

          setBannerData(response.data[0]);
          // console.log("banner data", response.data[0]);
          const image_banner = response.data[0].contentBackground;
          const image_url = process.env.REACT_APP_BASE_URL + image_banner;
          setBannerImage(image_url);
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        },
        (err) => {
          //error
          console.log(err);
        }
      );
    } else if (window.location.href.includes("futuristic") === true) {
      futuristicbannerAPI(
        config,
        (response) => {
          //success

          setBannerData(response.data[0]);
          // console.log("banner data", response.data[0]);
          const image_banner = response.data[0].contentBackground;
          const image_url = process.env.REACT_APP_BASE_URL + image_banner;
          setBannerImage(image_url);
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        },
        (err) => {
          //error
          console.log(err);
        }
      );
    } else if (window.location.href.includes("sap") === true) {
      sapbannerAPI(
        config,
        (response) => {
          //success

          setBannerData(response.data[0]);
          // console.log("banner data", response.data[0]);
          const image_banner = response.data[0].contentBackground;
          const image_url = process.env.REACT_APP_BASE_URL + image_banner;
          setBannerImage(image_url);
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        },
        (err) => {
          //error
          console.log(err);
        }
      );
    }
    else if (window.location.href.includes("solutions") === true) {
      servicebannerAPI(
        config,
        (response) => {
          //success

          setBannerData(response.data[0]);
          // console.log("banner data", response.data[0]);
          const image_banner = response.data[0].contentBackground;
          const image_url = process.env.REACT_APP_BASE_URL + image_banner;
          setBannerImage(image_url);
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        },
        (err) => {
          //error
          console.log(err);
        }
      );
    }
    else if (window.location.href.includes("services") === true) {
      raasbannerAPI(
        config,
        (response) => {
          //success

          setBannerData(response.data[0]);
          // console.log("banner data", response.data[0]);
          const image_banner = response.data[0].contentBackground;
          const image_url = process.env.REACT_APP_BASE_URL + image_banner;
          setBannerImage(image_url);
          setTimeout(() => {
            setLoading(false);
          }, 3000);
        },
        (err) => {
          //error
          console.log(err);
        }
      );
    }
  };
  useEffect(() => {
    getAllBannerData();
    window.addEventListener("load", handleLoading);
    return () => window.removeEventListener("load", handleLoading);
  }, []);
  return (
    <div>
      <div className="position-relative banner_mobile_height">
        {/* <img 
      src={bannerImage} 
      className="w-100"
       alt="Banner"/> */}
        <div className="bics-page-banner-container">
          {(function () {
            if (loading) {
              return (
                <div className="bics-loading">
                  <Animated animationIn="fadeIn" animationOut="fadeOut">
                    <LoadingBox />
                  </Animated>
                </div>
              );
            } else {
              return (
                <AnimatePresence>
                  <motion.div
                    className="bics-page-banner"
                    initial="initial"
                    animate="animate"
                    variants={text}
                  >
                    <Img
                      placeholder={bannerImage}
                      src={bannerImage}
                      className="w-100"
                      cache // Default is true, just for demo
                      alt="Bics Global Solution"
                    />
                  </motion.div>
                </AnimatePresence>
              );
            }
          })()}
        </div>
        {/* <Img
    placeholder={bannerImage}
    src={bannerImage}
    className="w-100"
    cache // Default is true, just for demo
    alt="REACT COOL IMG"
  /> */}
        <div className="position-absolute position_alignment w-100">
          <Container className="">
            <div className="banner_container">
              <AnimatedText
                type="chars" // animate words or chars
                animation={{
                  x: "200px",
                  y: "-20px",
                  scale: 1.1,
                  ease: "ease-in-out",
                }}
                animationType="lights"
                interval={0.1}
                duration={0.8}
                tag="p"
                
                className={`animated-heading contactus_head_title banner_title ${bannerTittleColor}`}
                includeWhiteSpaces
                threshold={0.2}
                rootMargin="20%"
              >
                {bannerData.contentTitle}
              </AnimatedText>

              <AnimatedText
                type="words" // animate words or chars
                animation={{
                  x: "200px",
                  y: "-20px",
                  scale: 1.1,
                  ease: "ease-in-out",
                }}
                animationType="wave"
                interval={0.06}
                duration={0.8}
                tag="p"
                className="animated-paragraph banner_description"
                includeWhiteSpaces
                threshold={0.1}
                rootMargin="20%"
              >
                {bannerData.contentDescription}
              </AnimatedText>
            </div>
          </Container>
        </div>
      </div>
    </div>
  );
};

export default PageBanner;
